module.exports = __webpack_public_path__ + "static/AvenirNext-Medium-6135a5d23c7575a2d15869bf91f605e4.woff2";